const selectTransport = document.getElementById('additional-input-transport');
const inputs = [...document.getElementsByClassName("transporterGroup")];

const setToggler = (event) => {
    let options = [...event.currentTarget.options];
    let selectedOption = options[event.currentTarget.selectedIndex];

    options.forEach(function(option) {
        if(document.getElementById(option.dataset.transportid))
            document.getElementById(option.dataset.transportid).style.display = 'none';
        if(document.getElementById(option.dataset.transport))
            document.getElementById(option.dataset.transport).style.display = 'none';
        if(document.getElementById('transportNameSingle'))
            document.getElementById('transportNameSingle').style.display = 'none';
        if(document.getElementById('transportNameGeneral'))
            document.getElementById('transportNameGeneral').style.display = 'none';        
        if(document.getElementById('transportNumber'))
            document.getElementById('transportNumber').style.display = 'none';
    });

    if(selectedOption.dataset.transport == 'transportAddress') {
        document.getElementById('transportNameSingle').style.display = '';
    } else if(selectedOption.dataset.transport == 'transportAddressNumber') {
        document.getElementById('transportNameSingle').style.display = '';
        document.getElementById('transportAddress').style.display = '';
        document.getElementById('transportNumber').style.display = '';
    } else if(selectedOption.dataset.transport == 'transportName') {
        document.getElementById('transportNameGeneral').style.display = '';
    } else if(selectedOption.dataset.transport == 'transportExternalAB') {
        document.getElementById('transportExternalAB').style.display = '';
        document.getElementById('transportExternalABRemarks').style.display = '';
    } else if(selectedOption.dataset.transport == 'transportExternalGD') {
        document.getElementById('transportExternalGD').style.display = '';
        document.getElementById('transportExternalGDRemarks').style.display = '';
    } else if(selectedOption.dataset.transport == 'transportExternalPC') {
        document.getElementById('transportExternalPC').style.display = '';
        document.getElementById('transportExternalPCRemarks').style.display = '';
    }
    if(document.getElementById(selectedOption.dataset.transport)) {
        document.getElementById(selectedOption.dataset.transport).style.display = '';
    }
    if(document.getElementById(selectedOption.dataset.transportid)) {
        document.getElementById(selectedOption.dataset.transportid).style.display = '';
    }

    if(selectedOption.dataset.transport == 'transportExternalAB' || selectedOption.dataset.transport == 'transportExternalGD' || selectedOption.dataset.transport == 'transportExternalPC') {
        document.getElementById('notTransportExternal').style.display = 'none';
        if(selectedOption.dataset.transport == 'transportExternalAB') {
            document.getElementById('deliveryOn').style.display = 'none';
            document.getElementById('transportExternalABRemarks').style.display = 'flex';
            document.getElementById('transportExternalGDRemarks').style.display = 'none';
            document.getElementById('transportExternalPCRemarks').style.display = 'none';
        } else if(selectedOption.dataset.transport == 'transportExternalGD') {
            document.getElementById('deliveryOn').style.display = '';
            document.getElementById('transportExternalABRemarks').style.display = 'none';
            document.getElementById('transportExternalGDRemarks').style.display = 'flex';
            document.getElementById('transportExternalPCRemarks').style.display = 'none';
        } else if(selectedOption.dataset.transport == 'transportExternalPC') {
            document.getElementById('deliveryOn').style.display = 'none';
            document.getElementById('transportExternalABRemarks').style.display = 'none';
            document.getElementById('transportExternalGDRemarks').style.display = 'none';
            document.getElementById('transportExternalPCRemarks').style.display = 'flex';
        }
    } else {
        document.getElementById('deliveryOn').style.display = '';
        document.getElementById('notTransportExternal').style.display = 'flex';
        document.getElementById('transportExternalABRemarks').style.display = 'none';
        document.getElementById('transportExternalGDRemarks').style.display = 'none';
        document.getElementById('transportExternalPCRemarks').style.display = 'none';
    }
}

const toggle = () => {;
    selectTransport.addEventListener('change', setToggler);  
}

export default () => {
    if(selectTransport)
    {
        toggle();
        var event = new Event('change');
        selectTransport.dispatchEvent(event);
    }
}
